var _rect, _rect2, _rect3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#C7C9C7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3897_10076",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3897_10076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 24.95C12.9833 24.7 11.3125 23.8208 9.9875 22.3125C8.6625 20.8042 8 19.0333 8 17C8 15.9 8.21667 14.8458 8.65 13.8375C9.08333 12.8292 9.7 11.95 10.5 11.2L11.925 12.625C11.2917 13.1917 10.8125 13.85 10.4875 14.6C10.1625 15.35 10 16.15 10 17C10 18.4667 10.4667 19.7625 11.4 20.8875C12.3333 22.0125 13.5333 22.7 15 22.95V24.95ZM17 24.95V22.95C18.45 22.6833 19.6458 21.9917 20.5875 20.875C21.5292 19.7583 22 18.4667 22 17C22 15.3333 21.4167 13.9167 20.25 12.75C19.0833 11.5833 17.6667 11 16 11H15.925L17.025 12.1L15.625 13.5L12.125 10L15.625 6.5L17.025 7.9L15.925 9H16C18.2333 9 20.125 9.775 21.675 11.325C23.225 12.875 24 14.7667 24 17C24 19.0167 23.3375 20.7792 22.0125 22.2875C20.6875 23.7958 19.0167 24.6833 17 24.95Z",
    fill: "#858585"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetGraph);
export default __webpack_public_path__ + "static/media/resetGraph.30430745e747be8496dadcbe2429eb8d.svg";
export { ForwardRef as ReactComponent };